"use strict";

var calculateTm = require("./calculateNebTm");

module.exports = function calculateNebTa(sequences, primerConc) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      monovalentCationConc = _ref.monovalentCationConc,
      polymerase = _ref.polymerase;

  try {
    if (sequences.length !== 2) {
      throw new Error(sequences.length + " sequences received when 2 primers were expected");
    }
    var meltingTemperatures = sequences.map(function (seq) {
      return calculateTm(seq, primerConc, { monovalentCationConc: monovalentCationConc });
    });
    meltingTemperatures.sort(function (a, b) {
      return a - b;
    });
    var lowerMeltingTemp = meltingTemperatures[0];
    var annealingTemp = void 0;
    if (polymerase === "Q5") {
      // Ta = Tm_lower+1°C is standard for Q5
      annealingTemp = lowerMeltingTemp + 1;
      if (annealingTemp > 72) {
        // "Annealing temperature for experiments with this enzyme should typically not exceed 72°C"
        annealingTemp = 72;
      }
    } else {
      annealingTemp = lowerMeltingTemp - 3;
    }
    return annealingTemp;
  } catch (err) {
    return "Error calculating annealing temperature: " + err;
  }
};